/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { UnitDropdownResponseDto } from '../model/unitDropdownResponseDto';
import { UnitPaginationResponseDto } from '../model/unitPaginationResponseDto';
import { UnitRequestDto } from '../model/unitRequestDto';
import { UnitResponseDto } from '../model/unitResponseDto';
import { ValidationError } from '../model/validationError';

export enum unitsDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum unitsGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum unitsIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class UnitsService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public unitsDropdownGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<Array<UnitDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/units/dropdown`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public unitsGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<UnitPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/units`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public unitsIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/units/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public unitsIdGet$(id: string, language?: string): Observable<UnitResponseDto> {
    return this.api.get(`${apiBaseUrl()}/units/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public unitsIdPut$(id: string, body: UnitRequestDto): Observable<UnitResponseDto> {
    return this.api.put(`${apiBaseUrl()}/units/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public unitsIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/units/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public unitsPost$(body: UnitRequestDto): Observable<UnitResponseDto> {
    return this.api.post(`${apiBaseUrl()}/units`, body, undefined);
  }
}
